import type {TeamMember} from '../../../pages/Team/teamFilters';
import type {groupSurfaceMessages} from './groupMessages';

export const presenceKey = (member: TeamMember): keyof typeof groupSurfaceMessages => {
    if (member.doNotDisturbUserStatus?.enabled) {
        return 'inviteSilent';
    }
    const status = member.telcoUserStatus?.status;
    if (status === 'TALKING') {
        return 'addTalking';
    }
    return !status || status === 'OFFLINE' || status === 'UNKNOWN' ? 'addOffline' : 'addAvailable';
};
